import React from 'react';
import Select from 'react-select';

const MainSelectPlus = ({
    title,
    value,
    name,
    onChange,
    options,
    required = false,
    disabled = false,
    readOnly = false,
}) => {
    const selectOptions = options?.map(opt => ({
        value: opt.id,
        label: opt.label
    }));

    const selectedOption = selectOptions?.find(opt => opt.value === value) || null;

    const handleChange = (selected) => {
        // Simula el mismo evento que el select nativo
        const fakeEvent = {
            target: {
                name,
                value: selected?.value
            }
        };
        onChange(fakeEvent);
    };

    return (
        <fieldset className='fieldset'>
            <legend className='title-legend'>{title}</legend>
            <Select
                options={selectOptions}
                value={selectedOption}
                onChange={handleChange}
                isDisabled={disabled || readOnly}
                placeholder={`Seleccionar ${title}`}
                isSearchable
                classNamePrefix="react-select"
            />
        </fieldset>
    );
};

export default MainSelectPlus;
